export default __webpack_public_path__ + "static/media/479.4400f0a4.png";